import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import GlobalModals from "./components/GlobalModals";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthProvider>
        <App />
        {/* Outside editor overflow stacks — modals always paint on top of the app */}
        <GlobalModals />
      </AuthProvider>
    </LanguageProvider>
  </React.StrictMode>
);
